import React from 'react';
import PropTypes from 'prop-types';

export default class FormError extends React.Component<any> {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,

        isCustom: PropTypes.bool,
        className: PropTypes.string
    }

    static defaultProps = {
        isCustom: false
    }

    componentDidMount() {
        this.props.form.registerErrorComponent(this.props.name,this);
    }

    componentWillUnmount() {
        this.props.form.unRegisterErrorComponent(this.props.name)
    }

    render() {
        if (!this.props.form.displayErrors || !this.props.form.fields[this.props.name].error) return false;

        const errorMessage = this.props.form.fields[this.props.name].error;

        console.log("Error message", errorMessage)

        return (
            <div className={Classes('error', this.props.className)}>
                {errorMessage}
            </div>
        );

    }
}
